import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { useParams } from 'react-router-dom';

import {
    IChangeAdditionalDocumentStatusErrorState,
    IChangeAdditionalDocumentStatusMainState,
} from '../ChangeAdditionalDocumentStatusDialog';
import { onConfirmChangeAdditionalDocumentStatus } from '../../../../../redux/project/documents/sliceProjectAdditionalDocumentChangeReleaseStatus';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({
    setShowErrorState,
    mainState,
    onClose,
}: IChangeAdditionalDocumentStatusDialogActionsProps) => {
    const { t } = useTranslation('translations', {
        keyPrefix: 'changeAdditionalDocumentStatusDialog',
    });
    const dispatch: Dispatch<unknown> = useDispatch();

    const { replicaId } = useParams();

    const { loading: isLoading, statusOptions } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocumentChangeReleaseStatus,
    );

    const validateInput = () => {
        setShowErrorState({
            command: !mainState.command,
        });
        return !!mainState.command;
    };
    const onChangeStatus = () => {
        if (validateInput()) {
            dispatch(onConfirmChangeAdditionalDocumentStatus({ replicaId, ...mainState }));
        }
    };
    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={isLoading}
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={statusOptions.length ? onChangeStatus : onClose}
                sx={buttonSx}
                disabled={isLoading}
            >
                {statusOptions.length ? t('ctaChange') : t('ctaUnderstood')}
            </Button>
        </DialogActions>
    );
};

interface IChangeAdditionalDocumentStatusDialogActionsProps {
    setShowErrorState: Dispatch<React.SetStateAction<IChangeAdditionalDocumentStatusErrorState>>;
    mainState: IChangeAdditionalDocumentStatusMainState;
    onClose: () => void;
}
